var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.onClick}},[_c('i',{class:{'app-show': !!_vm.number}},[_vm._v(_vm._s(_vm.number > 99 ? '99+' : _vm.number))]),_c('img',{class:{'app-animation': !!_vm.number},attrs:{"src":(_vm.imgUrl + "/2.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }